// SIP_WO_WATERFLOW_INDEPENDENT_V2
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import "../engineering-wo-public-menu-access-v1";

/* ========= THEME CSS (TIDAK DIUBAH) ========= */
const THEME_CSS = `
:root{
  --bg-body:#f6f8fc;
  --bg-card:#ffffff;
  --text-muted:#6b7280;
  --text-strong:#111827;
  --brand-primary:#3b82f6;
  --sidebar-text:#334155;
  --sidebar-icon:#64748b;
  --sidebar-active-bg:rgba(59,130,246,.12);
  --sidebar-active-text:#1d4ed8;
  --radius-lg:16px;
  --shadow-soft:0 10px 25px rgba(30,41,59,.06);
  --transition-all:220ms cubic-bezier(.2,.7,.2,1);
  --navbar-h: 60px;
  --sidebar-w: 320px;
  --sidebar-w-collapsed: 88px;
  --brand-h: 72px;
}
html, body, #root{ height:100%; margin:0; padding:0; }
body.no-scroll{ overflow:hidden; }
.content-wrapper{ background:var(--bg-body) !important; transition: margin var(--transition-all); }
.container-fluid{ animation:fadeIn .35s ease; }
@keyframes fadeIn{ from{opacity:0; transform:translateY(8px)} to{ opacity:1; transform:none } }
.route-animate{ animation:routeFade .28s ease; will-change: opacity, transform; }
@keyframes routeFade{ from{ opacity:0; transform:translateY(6px) } to{ opacity:1; transform:none } }
.main-header.navbar{
  position: fixed; top: 0; left: 0 !important; right: 0 !important;
  height: var(--navbar-h);
  padding-top: env(safe-area-inset-top, 0px);
  background:#3b82f6 !important;
  border-bottom:1px solid rgba(255,255,255,.15);
  z-index:1040; display:flex; align-items:center;
}
.wrapper .main-header{ margin-left:0 !important; width:100% !important; }

body .wrapper aside.main-sidebar{
  position: fixed !important; left:0 !important; right:auto;
  top: calc(var(--navbar-h) + env(safe-area-inset-top, 0px)) !important; bottom:0 !important;
  width: var(--sidebar-w) !important; z-index:1035; background:#d6e4fa !important;
  color:var(--sidebar-text); border-right:1px solid #cbd5e1; overflow:hidden;
  transition: width var(--transition-all), transform var(--transition-all);
}
.brand-link{
  height: var(--brand-h); display:flex; align-items:center; justify-content:flex-start;
  background:#d6e4fa !important; border-bottom:1px solid #cbd5e1 !important; margin:0 !important; padding:0 14px;
}
.brand-link .brand-inner{ display:flex; align-items:center; gap:1px; }
.brand-link .brand-logo{ height:100px; width:auto; object-fit:contain; display:block; }
.brand-text{ color:var(--text-strong) !important; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; margin-left:0; line-height:1.05; font-size:35px; }

.main-sidebar .sidebar{
  position:absolute; top: var(--brand-h); left:0; right:0; bottom:0;
  overflow-y:auto; overflow-x:hidden; padding:12px 0 72px;
  min-height:0; overscroll-behavior:contain; -webkit-overflow-scrolling:touch;
}

.nav-sidebar .nav-link{
  color:var(--sidebar-text) !important; font-weight:500; border-radius:10px;
  margin:2px 8px; transition:background var(--transition-all), color var(--transition-all), transform var(--transition-all);
  display:flex; align-items:center; gap:.5rem; min-height:44px;
}
.nav-sidebar .nav-link:hover{ background:#f1f5f9; transform:translateX(2px); }
.nav-sidebar .menu-open > .nav-link, .nav-sidebar .nav-link.active{ background:var(--sidebar-active-bg) !important; color:var(--sidebar-active-text) !important; }
.nav-sidebar .nav-link .menu-text{ flex:1 1 auto; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
.nav-sidebar .nav-link .right{ margin-left:auto; position:static !important; }
.nav-sidebar .nav-icon{ color:var(--sidebar-icon) !important; margin-right:10px; min-width:20px; text-align:center; }
.nav-sidebar .nav-link:hover .nav-icon{ color:var(--sidebar-active-text) !important; }

.nav-treeview.smooth{
  overflow:hidden;
  transition:max-height .28s ease, opacity .28s ease;
  opacity:1; border-left:2px solid #eef2f7; margin-left:.25rem; padding-left:.25rem;
  will-change:max-height,opacity;
}
.nav-treeview.smooth.closed{ max-height:0 !important; opacity:.0; padding-top:0; padding-bottom:0; }
.nav-treeview.smooth.open{
  max-height:9999px; opacity:1; overflow:visible;
}

.card, .small-box, .info-box{ border:none !important; border-radius:var(--radius-lg) !important; box-shadow:var(--shadow-soft) !important; overflow:hidden; }
.btn, .form-control{ border-radius:12px !important; transition:all var(--transition-all); background-clip:padding-box; }
.form-control:focus{ box-shadow:0 0 0 4px rgba(59,130,246,.12); border-color:#bfdbfe; }
.btn:active{ transform:translateY(1px); }

.main-footer{ border-top:1px solid #e5e7eb !important; color:var(--text-muted); background:#ffffff !important; }
.content-wrapper, .main-footer{ margin-top: var(--navbar-h) !important; margin-left: var(--sidebar-w) !important; min-height: calc(100vh - var(--navbar-h)); }

.wrapper.collapsed aside.main-sidebar{ width: var(--sidebar-w-collapsed) !important; }
.wrapper.collapsed .brand-link{ justify-content:center; padding:0; }
.wrapper.collapsed .brand-text{ opacity:0; width:0; }
.wrapper.collapsed .nav-sidebar .menu-text{ opacity:0; width:0; overflow:hidden; margin:0; }
.wrapper.collapsed .right{ opacity:0; width:0; overflow:hidden; }
.wrapper.collapsed .nav-sidebar .nav-icon{ margin-right:0; min-width:auto; }
.wrapper.collapsed .content-wrapper, .wrapper.collapsed .main-footer{ margin-left: var(--sidebar-w-collapsed) !important; }

@media (hover:hover){
  .wrapper.collapsed aside.main-sidebar:hover{ width: var(--sidebar-w) !important; }
  .wrapper.collapsed aside.main-sidebar:hover ~ .content-wrapper,
  .wrapper.collapsed aside.main-sidebar:hover ~ .main-footer{ margin-left: var(--sidebar-w) !important; }
  .wrapper.collapsed aside.main-sidebar:hover .brand-text,
  .wrapper.collapsed aside.main-sidebar:hover .nav-sidebar .menu-text,
  .wrapper.collapsed aside.main-sidebar:hover .right{ opacity:1; width:auto; }
}

@media (max-width: 991.98px){
  .content-wrapper, .main-footer{ margin-left:0 !important; }
  aside.main-sidebar{ transform: translateX(-100%) !important; width: var(--sidebar-w) !important; }
  .wrapper.show-drawer aside.main-sidebar, body.sidebar-open aside.main-sidebar{ transform: translateX(0) !important; }
  .wrapper.show-drawer .drawer-backdrop, body.sidebar-open .drawer-backdrop{
    position: fixed; top: calc(var(--navbar-h) + env(safe-area-inset-top, 0px)); left:0; right:0; bottom:0;
    background: rgba(0,0,0,.25); backdrop-filter: blur(1px); z-index:1029;
  }
  :root{ --brand-h: 60px; }
  .brand-link .brand-logo{ height:56px; }
  .brand-text{ font-size:20px; }
}
@media (max-width: 360px){
  :root{ --brand-h: 54px; }
  .brand-link .brand-logo{ height:50px; }
  .brand-text{ font-size:18px; }
}

@keyframes bell-bounce { 0%,100%{ transform: translateY(0) } 50%{ transform: translateY(-2px) } }
.navbar .notif-bell.has-badge { animation: bell-bounce 1s ease-in-out infinite; }

.bell-menu{
  position:absolute; right:0; top:100%; background:#fff; color:#111;
  border:1px solid #e5e7eb; border-radius:12px; box-shadow:var(--shadow-soft);
  min-width:240px; z-index:1060; overflow:hidden;
}
.bell-menu a, .bell-menu button{
  width:100%; text-align:left; background:none; border:none;
  padding:10px 12px; display:flex; align-items:center; gap:8px;
}
.bell-menu a:hover, .bell-menu button:hover{ background:#f8fafc; }
.modal-blanket{
  position:fixed; inset:0; background:rgba(0,0,0,.35);
  display:flex; align-items:center; justify-content:center; z-index:1065;
}
.risalah-modal{
  background:#fff; width:min(980px, 96vw); max-height:85vh; overflow:auto;
  border-radius:16px; box-shadow:var(--shadow-soft);
}
`;

/* === SIP_COMPANY_DOC_GROUPS_R1 === */
const COMPANY_DOC_GROUPS = [
  { key:"01", title:"01. Profil Perusahaan", items:[["01-company-profile","Company Profile"],["01-sejarah-perusahaan","Sejarah Perusahaan"],["01-visi-misi","Visi & Misi"],["01-nilai-perusahaan","Nilai-Nilai Perusahaan"],["01-struktur-organisasi","Struktur Organisasi"]] },
  { key:"02", title:"02. Kebijakan Perusahaan", items:[["02-kebijakan-mutu","Kebijakan Mutu"],["02-kebijakan-lingkungan","Kebijakan Lingkungan"],["02-kebijakan-k3","Kebijakan K3"],["02-kebijakan-energi","Kebijakan Energi"],["02-kebijakan-lainnya","Kebijakan Perusahaan Lainnya"]] },
  { key:"03", title:"03. Peraturan & Ketentuan", items:[["03-peraturan-perusahaan","Peraturan Perusahaan"],["03-tata-tertib","Tata Tertib"],["03-ketentuan-k3","Ketentuan K3"],["03-ketentuan-lingkungan","Ketentuan Lingkungan"],["03-ketentuan-internal-lainnya","Ketentuan Internal Lainnya"]] },
  { key:"04", title:"04. Quality Management System", items:[["04-quality-manual","Quality Manual"],["04-sop","SOP"],["04-work-instruction","Work Instruction"],["04-quality-standard","Quality Standard"],["04-quality-procedure","Quality Procedure"],["04-job-description","Job Description"],["04-quality-information","Quality Information"]] },
  { key:"05", title:"05. Environmental Management System", items:[["05-environmental-manual","Environmental Manual"],["05-environmental-procedure","Environmental Procedure"],["05-environmental-work-instruction","Environmental Work Instruction"],["05-environmental-standard","Environmental Standard"],["05-environmental-information","Environmental Information"]] },
  { key:"06", title:"06. Occupational Health & Safety", items:[["06-k3-manual","K3 Manual"],["06-k3-procedure","K3 Procedure"],["06-safety-work-instruction","Safety Work Instruction"],["06-safety-standard","Safety Standard"],["06-emergency-response","Emergency Response"],["06-safety-information","Safety Information"]] },
  { key:"07", title:"07. Informasi Departemen", items:[["07-ppic","PPIC"],["07-production","Production"],["07-quality","Quality"],["07-warehouse","Warehouse"],["07-engineering","Engineering"],["07-purchasing","Purchasing"],["07-hr-ga","HR & GA"],["07-finance","Finance"],["07-it","IT"]] },
  { key:"08", title:"08. Form & Template", items:[["08-form-perusahaan","Form Perusahaan"],["08-form-departemen","Form Departemen"],["08-template-excel","Template Excel"],["08-template-powerpoint","Template PowerPoint"],["08-template-surat","Template Surat"]] },
  { key:"09", title:"09. Informasi & Pengumuman", items:[["09-pengumuman-manajemen","Pengumuman Manajemen"],["09-informasi-perusahaan","Informasi Perusahaan"],["09-informasi-kegiatan","Informasi Kegiatan"],["09-informasi-training","Informasi Training"],["09-informasi-lainnya","Informasi Lainnya"]] },
  { key:"99", title:"99. Archive", items:[["99-obsolete-document","Obsolete Document"],["99-expired-document","Expired Document"],["99-historical-document","Historical Document"]] },
];
/* === END SIP_COMPANY_DOC_GROUPS_R1 === */

export default function DashboardLayout({
  children,
  role,
  username,
  permissions = [],
  deptRoles = [],
}) {
  const location = useLocation();
  const isSuperAdmin = String(username || "").toLowerCase() === "admin";

  const hasPerm = (key) => isSuperAdmin || (permissions || []).includes(key);

  const hasAnyPerm = (permList = []) => {
    if (isSuperAdmin) return true;
    if (!Array.isArray(permList)) return false;
    return permList.some((p) => (permissions || []).includes(p));
  };

  const DEPT_ALIAS = {
    engineering: ["eng", "engineering"],
    maintenance: ["mtc", "maintenance"],
    ppic: ["ppic"],
    quality: ["qa", "quality", "qmr"],
    produksi: ["prod", "produksi"],
    hrd: ["hr", "hrd"],
    ga: ["ga"],
    accounting: ["acc", "accounting"],
    it: ["it"],
    purchasing: ["purch", "purchasing"],
    warehouse: ["wh", "warehouse"],
  };

  const canSeeDept = (_deptName) => true;

const canSeeHRDMenu = () => {
  if (isSuperAdmin) return true;
  return hasAnyPerm([
    "hrd.skill_matrix.job_profile.view",
    "hrd.skill_matrix.job_profile.create",
    "hrd.skill_matrix.job_profile.update",
    "hrd.skill_matrix.job_profile.delete",
    "hrd.skill_matrix.job_profile.import",
    "hrd.skill_matrix.job_profile.export",

    "hrd.skill_matrix.rekap_training.view",
    "hrd.skill_matrix.rekap_training.create",
    "hrd.skill_matrix.rekap_training.update",
    "hrd.skill_matrix.rekap_training.delete",
    "hrd.skill_matrix.rekap_training.export",
    "hrd.skill_matrix.rekap_training.master",

    "hrd.matrix_training.view",
    "hrd.matrix_training.input",
    "hrd.matrix_training.update",
    "hrd.matrix_training.master",
    "hrd.matrix_training.export",
  ]);
};

  const canSeeHRDJobProfile = hasAnyPerm([
    "hrd.skill_matrix.job_profile.view",
    "hrd.skill_matrix.job_profile.create",
    "hrd.skill_matrix.job_profile.update",
    "hrd.skill_matrix.job_profile.delete",
    "hrd.skill_matrix.job_profile.import",
    "hrd.skill_matrix.job_profile.export",
  ]);
  
  const canSeeHRDRekapTraining = hasAnyPerm([
  "hrd.skill_matrix.rekap_training.view",
  "hrd.skill_matrix.rekap_training.create",
  "hrd.skill_matrix.rekap_training.update",
  "hrd.skill_matrix.rekap_training.delete",
  "hrd.skill_matrix.rekap_training.export",
  "hrd.skill_matrix.rekap_training.master",
]);

  const canSeeHRDMatrixTraining = hasAnyPerm([
    "hrd.matrix_training.view",
    "hrd.matrix_training.input",
    "hrd.matrix_training.update",
    "hrd.matrix_training.master",
    "hrd.matrix_training.export",
  ]);

  const [pendingCount, setPendingCount] = useState(0);
  const PENDING_COUNT_API = "/api/booking/pending-count";

  const fetchJsonWithTimeout = async (url, opts = {}, timeoutMs = 8000) => {
    const controller = new AbortController();
    const t = setTimeout(() => controller.abort(), timeoutMs);

    try {
      const res = await fetch(url, {
        ...opts,
        signal: controller.signal,
        headers: {
          Accept: "application/json",
          ...(opts.headers || {}),
        },
      });

      const ct = (res.headers.get("content-type") || "").toLowerCase();
      const text = await res.text();

      if (!res.ok) throw new Error(`HTTP ${res.status} ${text.slice(0, 120)}`);
      if (!ct.includes("application/json")) {
        throw new Error(`Non-JSON response: ${text.slice(0, 120)}`);
      }
      return JSON.parse(text);
    } finally {
      clearTimeout(t);
    }
  };

  useEffect(() => {
    if (role !== "admin") return;

    let alive = true;

    const fetchPending = async () => {
      try {
        const data = await fetchJsonWithTimeout(PENDING_COUNT_API, {}, 6000);
        const count =
          typeof data?.count === "number"
            ? data.count
            : typeof data === "number"
            ? data
            : 0;

        if (alive) setPendingCount(count);
      } catch (e) {
        console.warn("Pending count fetch failed:", e?.message || e);

        try {
          const list = await fetchJsonWithTimeout("/api/booking", {}, 6000);
          const count = Array.isArray(list)
            ? list.filter(
                (b) =>
                  String(b.status || "").trim().toLowerCase() === "pending"
              ).length
            : 0;
          if (alive) setPendingCount(count);
        } catch {
          if (alive) setPendingCount(0);
        }
      }
    };

    fetchPending();
    const id = setInterval(fetchPending, 60000);

    return () => {
      alive = false;
      clearInterval(id);
    };
  }, [role]);

  const safeGet = (k) => {
    try {
      return localStorage.getItem(k);
    } catch {
      return null;
    }
  };
  const safeSet = (k, v) => {
    try {
      localStorage.setItem(k, v);
    } catch {}
  };

  const [collapsed, setCollapsed] = useState(
    () => safeGet("sidebar-collapsed") === "true"
  );
  useEffect(() => {
    safeSet("sidebar-collapsed", String(collapsed));
  }, [collapsed]);

  const [drawerOpen, setDrawerOpen] = useState(false);
  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const body = document.body;
    if (drawerOpen) body.classList.add("no-scroll", "sidebar-open");
    else body.classList.remove("no-scroll", "sidebar-open");
    return () => body.classList.remove("no-scroll", "sidebar-open");
  }, [drawerOpen]);

  const handleSidebarClick = (e) => {
    const link = e.target.closest("a.nav-link");
    if (!link) return;
    if (window.innerWidth <= 991) setDrawerOpen(false);
  };

  const [bellOpen, setBellOpen] = useState(false);
  const [showRisalah, setShowRisalah] = useState(false);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        setDrawerOpen(false);
        setBellOpen(false);
        setShowRisalah(false);
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    const onResize = () => {
      if (window.innerWidth > 991) setDrawerOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  const handleToggleSidebar = () => {
    if (window.innerWidth <= 991) setDrawerOpen((v) => !v);
    else setCollapsed((v) => !v);
  };

  const [openDept, setOpenDept] = useState(false);
  const [openPPIC, setOpenPPIC] = useState(false);
  const [openHRD, setOpenHRD] = useState(false);
  const [openSkillMatrix, setOpenSkillMatrix] = useState(false);
  const [openPlanProduk, setOpenPlanProduk] = useState(false);
  const [openDelivery, setOpenDelivery] = useState(false);
  const [openWarehouse, setOpenWarehouse] = useState(false);
  const [openRoom, setOpenRoom] = useState(false);
  const [openDokumen, setOpenDokumen] = useState(false);
  const [openDokumenInternal, setOpenDokumenInternal] = useState(false);
  const [openDokumenEksternal, setOpenDokumenEksternal] = useState(false);
  const [openCompanyDocGroups, setOpenCompanyDocGroups] = useState({});
  const [openEngineering, setOpenEngineering] = useState(false);
  const [openMaintenance, setOpenMaintenance] = useState(false);
  const [openQuality, setOpenQuality] = useState(false);
  const [openProduksi, setOpenProduksi] = useState(false);
  const [openIT, setOpenIT] = useState(false);

  const treeClass = (isOpen) =>
    `nav nav-treeview smooth ${isOpen ? "open" : "closed"}`;
  const wrapperClass = `wrapper ${collapsed ? "collapsed" : ""} ${
    drawerOpen ? "show-drawer" : ""
  }`;

  const [risalahRows, setRisalahRows] = useState([]);
  const RISALAH_NOTICE_API = "/api/risalah/notice";
  const effDepts = (deptRoles || [])
    .map((d) => String(d || "").trim())
    .filter(Boolean);

  const fetchRisalahNotice = async () => {
    try {
      const tokens = (deptRoles || []).map((d) => encodeURIComponent(String(d)));
      const qs =
        isSuperAdmin || tokens.length === 0
          ? ""
          : `?depts=${tokens.join(",")}`;
      const res = await fetch(`${RISALAH_NOTICE_API}${qs}`);
      const data = await res.json();
      setRisalahRows(Array.isArray(data) ? data : []);
    } catch (e) {
      console.error("Gagal ambil notice risalah", e);
      setRisalahRows([]);
    }
  };

  const openRisalahModal = async () => {
    await fetchRisalahNotice();
    setShowRisalah(true);
    setBellOpen(false);
  };

  const canSeeEngineeringMenu =
    canSeeDept("Engineering") && hasAnyPerm(["engineering.wo.view", "monitoring.waterflow"]);

  const canSeeMaintenanceMenu =
    canSeeDept("Maintenance") && hasAnyPerm([]);

  const canSeePPICMenu =
    canSeeDept("PPIC") &&
    hasAnyPerm([
      "monitoring.display",
      "monitoring.delivery",
      "report.delivery",
      "ppic.sj_rpb.view",
      "ppic.sj_rpb.view",
      "prep.monitor",
      "prep.input",
      "delip.monitor",
      "delip.input",
      "materials.view",
      "komponen.input",
      "plate.input",
      "pipa.input",
      "mt.kedatangan.view",
      "mt.kedatangan.dashboard",
    ]);

  const canSeeQualityMenu =
    canSeeDept("Quality") && hasAnyPerm(["kakotora.view"]);

  const canSeeProduksiMenu =
    canSeeDept("Produksi") && hasAnyPerm(["oee.view", "produksi.henkaten.view"]);
    
    const canSeeITMenu =
  canSeeDept("IT") &&
  hasAnyPerm([
    "it.ticketing.view",
    "it.ticketing.create",
    "it.ticketing.handle.infrastruktur",
    "it.ticketing.handle.erp",
    "it.ticketing.handle.aplikasi",
    "it.ticketing.report",
    "it.ticketing.master",
    "it.ticketing.export",
    "it.ticketing.print",
    "it.schedule_maintenance.view",
    "it.schedule_maintenance.input",
    "it.schedule_maintenance.master",
    "it.schedule_maintenance.export",
  "it.schedule_maintenance.delete",
  "it.schedule_maintenance.approve",
  "it.schedule_maintenance.reset_user",
    "it.cctv_monitor.view",
  ]);

    const canSeeDashboardDivisi =
      canSeeEngineeringMenu ||
      canSeeMaintenanceMenu ||
      canSeePPICMenu ||
      canSeeQualityMenu ||
      canSeeProduksiMenu ||
      canSeeITMenu ||
      canSeeHRDMenu();
      
  useEffect(() => {
    if (isSuperAdmin) {
      setOpenDept(true);
      return;
    }

    if (canSeeEngineeringMenu) {
      setOpenDept(true);
      setOpenEngineering(true);
    }

    if (canSeeMaintenanceMenu) {
      setOpenDept(true);
      setOpenMaintenance(true);
    }

    if (canSeePPICMenu) {
      setOpenDept(true);
      setOpenPPIC(true);
    }

    if (canSeeQualityMenu) {
      setOpenDept(true);
      setOpenQuality(true);
    }

    if (canSeeProduksiMenu) {
      setOpenDept(true);
      setOpenProduksi(true);
    }
    
    if (canSeeITMenu) {
      setOpenDept(true);
      setOpenIT(true);
    }

    if (canSeeHRDMenu()) {
      setOpenHRD(true);
      setOpenSkillMatrix(true);
    }
  }, [
    role,
    deptRoles,
    permissions,
    canSeeEngineeringMenu,
    canSeeMaintenanceMenu,
    canSeePPICMenu,
    canSeeQualityMenu,
    canSeeProduksiMenu,
    canSeeITMenu,
  ]);

  return (
    <div className={wrapperClass}>
      <style>{THEME_CSS}</style>

      <nav
        className="main-header navbar navbar-expand navbar-dark bg-primary"
        role="navigation"
        aria-label="Main navigation"
      >
        <ul className="navbar-nav align-items-center">
          <li className="nav-item">
            <button
              className="btn btn-sm btn-outline-light ml-2"
              onClick={handleToggleSidebar}
              aria-label="Toggle sidebar"
              aria-expanded={drawerOpen}
              aria-controls="app-sidebar"
            >
              <i className="fas fa-bars" />
            </button>
          </li>
        </ul>

        <ul className="navbar-nav ml-auto align-items-center">
          <li className="nav-item mr-3 position-relative">
            <button
              className={`btn btn-sm btn-outline-light position-relative notif-bell ${
                pendingCount > 0 ? "has-badge" : ""
              }`}
              title="Notifikasi"
              onClick={() => setBellOpen((v) => !v)}
            >
              <i className="fas fa-bell" />
              {pendingCount > 0 && (
                <span
                  className="badge badge-danger position-absolute"
                  style={{
                    top: -6,
                    right: -8,
                    borderRadius: 10,
                    padding: "2px 6px",
                    fontSize: 11,
                  }}
                >
                  {pendingCount}
                </span>
              )}
            </button>

            {bellOpen && (
              <div className="bell-menu">
                <Link to="/daftar" onClick={() => setBellOpen(false)}>
                  <i className="fas fa-door-open" /> Booking Room
                </Link>
                <button type="button" onClick={openRisalahModal}>
                  <i className="fas fa-file-alt" /> Risalah Meeting
                </button>
              </div>
            )}
          </li>

          <li className="nav-item mr-3 text-white">
            <span className="text-white">
              <i className="fas fa-user-circle mr-1" /> {username}
            </span>
          </li>

          <li className="nav-item">
            <button
              className="btn btn-sm btn-outline-light"
              onClick={() => {
                try {
                  localStorage.removeItem("user");
                  localStorage.removeItem("token");
                  sessionStorage.removeItem("user");
                  sessionStorage.removeItem("token");
                } catch {}
                window.location.href = "/login";
              }}
            >
              <i className="fas fa-sign-out-alt" /> Logout
            </button>
          </li>
        </ul>
      </nav>

      {(drawerOpen || document.body.classList.contains("sidebar-open")) && (
        <div
          className="drawer-backdrop"
          onClick={() => setDrawerOpen(false)}
          aria-hidden="true"
        />
      )}

      <aside
        id="app-sidebar"
        className="main-sidebar sidebar-dark-primary elevation-4"
        aria-label="Sidebar"
      >
        <Link to="/" className="brand-link" style={{ textDecoration: "none" }}>
          <div className="brand-inner">
            <img
              src="/api/uploads/ruangan/IT%20logo.png"
              alt="SIP Logo"
              className="brand-logo"
            />
            <span className="brand-text font-weight-bold">Office</span>
          </div>
        </Link>

        <div className="sidebar" onClick={handleSidebarClick}>
          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" role="menu">
              {hasPerm("dashboard.view") && (
                <li className="nav-item" title="Dashboard SIP">
                  <Link to="/" className="nav-link">
                    <i className="nav-icon fas fa-home" />
                    <span className="menu-text">Home</span>
                  </Link>
                </li>
              )}

              {(hasPerm("room.add") || hasPerm("room.list")) && (
                <li
                  className={`nav-item has-treeview ${openRoom ? "menu-open" : ""}`}
                  title="Room Meeting"
                >
                  <a
                    href="#!"
                    className="nav-link"
                    onClick={() => setOpenRoom(!openRoom)}
                  >
                    <i className="nav-icon fas fa-door-open" />
                    <span className="menu-text">Room Meeting</span>
                    <i className="right fas fa-angle-left" />
                  </a>
                  <ul className={treeClass(openRoom)}>
                    {hasPerm("room.add") && (
                      <li className="nav-item" title="Tambah Booking">
                        <Link to="/form" className="nav-link">
                          <i className="nav-icon fas fa-plus-circle" />
                          <span className="menu-text">Tambah Booking</span>
                        </Link>
                      </li>
                    )}
                    {hasPerm("room.list") && (
                      <li className="nav-item" title="Daftar Booking">
                        <Link to="/daftar" className="nav-link">
                          <i className="nav-icon fas fa-list-alt" />
                          <span className="menu-text">Daftar Booking</span>
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}

              {canSeeDashboardDivisi && (
                <li
                  className={`nav-item has-treeview ${openDept ? "menu-open" : ""}`}
                  title="Dashboard Divisi"
                >
                  <a
                    href="#!"
                    className="nav-link"
                    onClick={() => setOpenDept(!openDept)}
                  >
                    <i className="nav-icon fas fa-building" />
                    <span className="menu-text">Dashboard Divisi</span>
                    <i className="right fas fa-angle-left" />
                  </a>

                  <ul className={treeClass(openDept)}>
                    {canSeeQualityMenu && (
                      <li
                        className={`nav-item has-treeview ${
                          openQuality ? "menu-open" : ""
                        }`}
                        title="Quality"
                      >
                        <a
                          href="#!"
                          className="nav-link"
                          onClick={() => setOpenQuality((v) => !v)}
                        >
                          <i className="nav-icon fas fa-check-circle" />
                          <span className="menu-text">Quality</span>
                          <i className="right fas fa-angle-left" />
                        </a>

                        <ul className={treeClass(openQuality) + " ml-3"}>
                          {hasPerm("kakotora.view") && (
                            <li className="nav-item" title="Kakotora (CAR System)">
                              <Link to="/kakotora" className="nav-link">
                                <i className="nav-icon fas fa-clipboard-check" />
                                <span className="menu-text">Kakotora</span>
                              </Link>
                              <Link to="/quality/readmine-jig-master-part" className="nav-link">
                                <i className="nav-icon fas fa-bell" />
                                <span className="menu-text">Readmine Jig & Master Part</span>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </li>
                    )}

                    {(isSuperAdmin || canSeeHRDMenu()) && (
                      <li
                        className={`nav-item has-treeview ${openHRD ? "menu-open" : ""}`}
                        title="HRD"
                      >
                        <a
                          href="#!"
                          className="nav-link"
                          onClick={() => setOpenHRD(!openHRD)}
                        >
                          <i className="nav-icon fas fa-users" />
                          <span className="menu-text">HRD</span>
                          <i className="right fas fa-angle-left" />
                        </a>

                        <ul className={treeClass(openHRD)}>
                          <li
                            className={`nav-item has-treeview ${
                              openSkillMatrix ? "menu-open" : ""
                            }`}
                            title="Skill Matrix"
                          >
                            <a
                              href="#!"
                              className="nav-link"
                              onClick={() => setOpenSkillMatrix(!openSkillMatrix)}
                            >
                              <i className="nav-icon fas fa-table" />
                              <span className="menu-text">Skill Matrix</span>
                              <i className="right fas fa-angle-left" />
                            </a>

                            <ul className={treeClass(openSkillMatrix) + " ml-3"}>
                              {canSeeHRDJobProfile && (
                                <li className="nav-item" title="Data Karyawan">
                                  <Link
                                    to="/hrd/skill-matrix/job-profile"
                                    className="nav-link"
                                  >
                                    <i className="nav-icon fas fa-id-card" />
                                    <span className="menu-text">Job Profile</span>
                                  </Link>
                                </li>
                              )}
                              {canSeeHRDRekapTraining && (
                                <li className="nav-item" title="Rekap Training">
                                  <Link to="/hrd/skill-matrix/rekap-training" className="nav-link">
                                    <i className="nav-icon fas fa-chalkboard-teacher" />
                                    <span className="menu-text">Rekap Training</span>
                                  </Link>
                                </li>
                              )}
{canSeeHRDRekapTraining && (
                                <li className="nav-item" title="Rekap Negatif Poin">
                                  <Link to="/hrd/rekap-negatif-poin" className="nav-link">
                                    <i className="nav-icon fas fa-chalkboard-teacher" />
                                    <span className="menu-text">Rekap Negatif Poin</span>
                                  </Link>
                                </li>
                              )}
{canSeeHRDRekapTraining && (
                                <li className="nav-item" title="Rekap Sanksi">
                                  <Link to="/hrd/skill-matrix/rekap-sanksi" className="nav-link">
                                    <i className="nav-icon fas fa-chalkboard-teacher" />
                                    <span className="menu-text">Rekap Sanksi</span>
                                  </Link>
                                </li>
                              )}
                              {canSeeHRDMatrixTraining && (
                                <li className="nav-item" title="Matrik Training Karyawan">
                                  <Link to="/hrd/matrix-training" className="nav-link">
                                    <i className="nav-icon fas fa-table" />
                                    <span className="menu-text">Matrik Training Karyawan</span>
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </li>
                        </ul>
                      </li>
                    )}

                    {canSeeProduksiMenu && (
                      <li
                        className={`nav-item has-treeview ${
                          openProduksi ? "menu-open" : ""
                        }`}
                        title="Produksi"
                      >
                        <a
                          href="#!"
                          className="nav-link"
                          onClick={() => setOpenProduksi((v) => !v)}
                        >
                          <i className="nav-icon fas fa-industry" />
                          <span className="menu-text">Produksi</span>
                          <i className="right fas fa-angle-left" />
                        </a>

                        <ul className={treeClass(openProduksi) + " ml-3"}>
                          {hasPerm("oee.view") && (
                            <li className="nav-item" title="OEE">
                              <Link to="/produksi/oee" className="nav-link">
                                <i className="nav-icon fas fa-chart-line" />
                                <span className="menu-text">OEE</span>
                              </Link>
                            </li>
                          )}
                          {hasPerm("produksi.henkaten.view") && (
                            <li className="nav-item" title="Henkaten">
                              <Link to="/produksi/henkaten" className="nav-link">
                                <i className="nav-icon fas fa-exchange-alt" />
                                <span className="menu-text">Henkaten (4M)</span>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </li>
                    )}
                    
                    {canSeeITMenu && (
                      <li
                        className={`nav-item has-treeview ${openIT ? "menu-open" : ""}`}
                        title="IT"
                      >
                        <a
                          href="#!"
                          className="nav-link"
                          onClick={() => setOpenIT((v) => !v)}
                        >
                          <i className="nav-icon fas fa-laptop-code" />
                          <span className="menu-text">IT</span>
                          <i className="right fas fa-angle-left" />
                        </a>
                    
                        <ul className={treeClass(openIT) + " ml-3"}>
                          {hasPerm("it.ticketing.view") && (
                            <li className="nav-item" title="Ticketing Problem">
                              <Link to="/it/ticketing-problem" className="nav-link">
                                <i className="nav-icon fas fa-ticket-alt" />
                                <span className="menu-text">Ticketing Problem</span>
                              </Link>
                            </li>
                          )}
                          {hasPerm("it.schedule_maintenance.view") && (
                            <li className="nav-item" title="Schedule Maintenance">
                              <Link to="/it/schedule-maintenance" className="nav-link">
                                <i className="nav-icon fas fa-tools" />
                                <span className="menu-text">Schedule Maintenance</span>
                              </Link>
                            </li>
                          )}
                          {hasPerm("it.cctv_monitor.view") && (
                            <li className="nav-item" title="Schedule CCTV / NVR">
                              <Link to="/it/cctv-monitor" className="nav-link">
                                <i className="nav-icon fas fa-video" />
                                <span className="menu-text">Schedule CCTV</span>
                              </Link>
                            </li>
                          )}
                        </ul>
                      </li>
                    )}

                    {canSeeEngineeringMenu && (
                      <li
                        className={`nav-item has-treeview ${
                          openEngineering ? "menu-open" : ""
                        }`}
                        title="Engineering"
                      >
                        <a
                          href="#!"
                          className="nav-link"
                          onClick={() => setOpenEngineering((v) => !v)}
                        >
                          <i className="nav-icon fas fa-tools" />
                          <span className="menu-text">Engineering</span>
                          <i className="right fas fa-angle-left" />
                        </a>

                        <ul className={treeClass(openEngineering) + " ml-3"}>
                          {hasAnyPerm(["engineering.wo.view", "monitoring.waterflow"]) && (
                            <li className="nav-item" title="Water Flow">
                              {hasAnyPerm([
                            "engineering.wo.view",
                            "engineering.wo.dashboard",
                            "engineering.wo.list",
                            "engineering.wo.engineering",
                            "engineering.wo.admin",
                            "engineering.wo.print",
                            "engineering.wo.delete",
                          ]) && (
                            hasAnyPerm([
                            "engineering.wo.view",
                            "engineering.wo.dashboard",
                            "engineering.wo.list",
                            "engineering.wo.engineering",
                            "engineering.wo.admin",
                            "engineering.wo.print",
                            "engineering.wo.delete",
                          ]) && (
                            <li className="nav-item" title="Aplikasi WO">
                              {hasPerm("engineering.wo.view") && (<Link to="/engineering/wo" className="nav-link">
                                <i className="nav-icon fas fa-tools" />
                                <span className="menu-text">Aplikasi WO</span>
                              </Link>)}
                            </li>
                          )
                          )}
{hasPerm("monitoring.waterflow") && (<Link to="/monitoring-water-flow" className="nav-link">
                                <i className="nav-icon fas fa-tint" />
                                <span className="menu-text">Water Flow</span>
                              </Link>)}
                            </li>
                          )}
                        </ul>
                      </li>
                    )}

                    {canSeeMaintenanceMenu && (
                      <li
                        className={`nav-item has-treeview ${
                          openMaintenance ? "menu-open" : ""
                        }`}
                        title="Maintenance"
                      >
                        <a
                          href="#!"
                          className="nav-link"
                          onClick={() => setOpenMaintenance((v) => !v)}
                        >
                          <i className="nav-icon fas fa-wrench" />
                          <span className="menu-text">Maintenance</span>
                          <i className="right fas fa-angle-left" />
                        </a>

                        <ul className={treeClass(openMaintenance) + " ml-3"}>
                          <li className="nav-item">
                            <span className="nav-link">
                              <i className="nav-icon fas fa-info-circle" />
                              <span className="menu-text">Belum ada menu</span>
                            </span>
                          </li>
                        </ul>
                      </li>
                    )}

                    {canSeePPICMenu && (
                      <li
                        className={`nav-item has-treeview ${openPPIC ? "menu-open" : ""}`}
                        title="PPIC"
                      >
                        <a
                          href="#!"
                          className="nav-link"
                          onClick={() => setOpenPPIC(!openPPIC)}
                        >
                          <i className="nav-icon fas fa-sitemap" />
                          <span className="menu-text">PPIC</span>
                          <i className="right fas fa-angle-left" />
                        </a>

                        <ul className={treeClass(openPPIC) + " ml-3"}>
                          <li
                            className={`nav-item has-treeview ${
                              openPlanProduk ? "menu-open" : ""
                            }`}
                            title="Plan Produk"
                          >
                            <a
                              href="#!"
                              className="nav-link"
                              onClick={() => setOpenPlanProduk(!openPlanProduk)}
                            >
                              <i className="nav-icon fas fa-cubes" />
                              <span className="menu-text">Plan Produk</span>
                              <i className="right fas fa-angle-left" />
                            </a>

                            <ul className={treeClass(openPlanProduk) + " ml-3"}>
                              {((hasPerm("monitoring.display") ||
                                hasPerm("monitoring.delivery") ||
                                hasPerm("report.delivery") ||
                                hasPerm("prep.monitor") ||
                                hasPerm("prep.input") ||
                                hasPerm("delip.monitor") ||
                                hasPerm("delip.input") || hasPerm("ppic.sj_rpb.view"))) && (
                                <li
                                  className={`nav-item has-treeview ${
                                    openDelivery ? "menu-open" : ""
                                  }`}
                                  title="Delivery"
                                >
                                  <a
                                    href="#!"
                                    className="nav-link"
                                    onClick={() => setOpenDelivery(!openDelivery)}
                                  >
                                    <i className="nav-icon fas fa-truck-loading" />
                                    <span className="menu-text">Delivery</span>
                                    <i className="right fas fa-angle-left" />
                                  </a>

                                  <ul className={treeClass(openDelivery) + " ml-3"}>
                                    {hasPerm("monitoring.display") && (
                                      <li className="nav-item" title="Monitoring Display">
                                        <Link to="/monitoring-display" className="nav-link">
                                          <i className="nav-icon fas fa-truck" />
                                          <span className="menu-text">Monitoring Display</span>
                                        </Link>
                                      </li>
                                    )}

                                    {hasPerm("monitoring.delivery") && (
                                      <li className="nav-item" title="Prepare Delivery">
                                        <Link to="/dashboard" className="nav-link">
                                          <i className="nav-icon fas fa-truck" />
                                          <span className="menu-text">Prepare Delivery</span>
                                        </Link>
                                      </li>
                                    )}

                                    {hasPerm("report.delivery") && (
                                      <li className="nav-item" title="Report Delivery">
                                        <Link to="/report" className="nav-link">
                                          <i className="nav-icon fas fa-file-alt" />
                                          <span className="menu-text">Report Delivery</span>
                                        </Link>
                                      </li>
                                    )}

                                    {hasPerm("ppic.sj_rpb.view") && (
                                      <li className="nav-item" title="Monitoring SJ vs RPB">
                                        <Link to="/ppic/sj-rpb" className="nav-link">
                                          <i className="nav-icon fas fa-clipboard-list" />
                                          <span className="menu-text">Monitoring SJ vs RPB</span>
                                        </Link>
                                      </li>
                                    )}

                                    {hasPerm("delip.monitor") && (
                                      <li className="nav-item" title="Monitoring Armada (DELIP)">
                                        <Link to="/delip/monitor" className="nav-link">
                                          <i className="nav-icon fas fa-eye" />
                                          <span className="menu-text">(DELIP)</span>
                                        </Link>
                                      </li>
                                    )}

                                    {hasPerm("delip.input") && (
                                      <li className="nav-item" title="Persiapan Armada (DELIP)">
                                        <Link to="/delip/input" className="nav-link">
                                          <i className="nav-icon fas fa-edit" />
                                          <span className="menu-text">(DELIP) INPUT</span>
                                        </Link>
                                      </li>
                                    )}

                                    {hasPerm("prep.monitor") && (
                                      <li className="nav-item" title="Prep Monitor">
                                        <Link to="/prep/monitor" className="nav-link">
                                          <i className="nav-icon fas fa-eye" />
                                          <span className="menu-text">Prep Monitor</span>
                                        </Link>
                                      </li>
                                    )}

                                    {hasPerm("prep.input") && (
                                      <li className="nav-item" title="Prep Input">
                                        <Link to="/prep/input" className="nav-link">
                                          <i className="nav-icon fas fa-edit" />
                                          <span className="menu-text">Prep Input</span>
                                        </Link>
                                      </li>
                                    )}
                                  </ul>
                                </li>
                              )}

                              {(hasPerm("materials.view") ||
                                hasPerm("komponen.input") ||
                                hasPerm("plate.input") ||
                                hasPerm("pipa.input") ||
                                hasPerm("mt.kedatangan.view") ||
                                hasPerm("mt.kedatangan.dashboard")) && (
                                <li
                                  className={`nav-item has-treeview ${
                                    openWarehouse ? "menu-open" : ""
                                  }`}
                                  title="Warehouse Material"
                                >
                                  <a
                                    href="#!"
                                    className="nav-link"
                                    onClick={() => setOpenWarehouse(!openWarehouse)}
                                  >
                                    <i className="nav-icon fas fa-warehouse" />
                                    <span className="menu-text">Warehouse Material</span>
                                    <i className="right fas fa-angle-left" />
                                  </a>

                                  <ul className={treeClass(openWarehouse) + " ml-3"}>
                                    {hasPerm("materials.view") && (
                                      <li className="nav-item" title="Dashboard Material">
                                        <Link to="/material/dashboard" className="nav-link">
                                          <i className="nav-icon fas fa-cubes" />
                                          <span className="menu-text">Dashboard Material</span>
                                        </Link>
                                      </li>
                                    )}

                                    {hasPerm("komponen.input") && (
                                      <li className="nav-item" title="Input Harian Komponen">
                                        <Link to="/komponen" className="nav-link">
                                          <i className="nav-icon fas fa-boxes" />
                                          <span className="menu-text">Input Harian Komponen</span>
                                        </Link>
                                      </li>
                                    )}

                                    {(hasPerm("mt.kedatangan.view") ||
                                      hasPerm("mt.kedatangan.dashboard")) && (
                                      <li
                                        className="nav-item has-treeview menu-open"
                                        title="Kedatangan Material"
                                      >
                                        <a href="#!" className="nav-link">
                                          <i className="nav-icon fas fa-truck-loading" />
                                          <span className="menu-text">Kedatangan Material</span>
                                          <i className="right fas fa-angle-left" />
                                        </a>

                                        <ul className="nav nav-treeview smooth open ml-3">
                                          {hasPerm("mt.kedatangan.view") && (
                                            <li className="nav-item">
                                              <Link
                                                to="/mt/kedatangan-material"
                                                className="nav-link"
                                              >
                                                <i className="nav-icon fas fa-table" />
                                                <span className="menu-text">Input / Grid</span>
                                              </Link>
                                            </li>
                                          )}

                                          {hasPerm("mt.kedatangan.dashboard") && (
                                            <li className="nav-item">
                                              <Link
                                                to="/mt/kedatangan-material/dashboard"
                                                className="nav-link"
                                              >
                                                <i className="nav-icon fas fa-chart-bar" />
                                                <span className="menu-text">
                                                  Dashboard Kedatangan
                                                </span>
                                              </Link>
                                            </li>
                                          )}
                                        </ul>
                                      </li>
                                    )}
                                  </ul>
                                </li>
                              )}
                            </ul>
                          </li>
                        </ul>
                      </li>
                    )}
                  </ul>
                </li>
              )}

{/* SIP_COMPANY_DOC_MENU_R1 */}
              {hasAnyPerm([
                "docs.company.view", "docs.company.create", "docs.company.update",
                "docs.company.delete", "docs.company.admin",
                "docs.internal.sop", "docs.internal.peraturan", "docs.external.iso",
                "docs.internal.view", "docs.external.view", "docs.create", "docs.update",
                "docs.delete", "docs.approve"
              ]) && (
                <li className={`nav-item has-treeview ${openDokumen ? "menu-open" : ""}`} title="Dokumen Perusahaan">
                  <a href="#!" className="nav-link" onClick={() => setOpenDokumen(!openDokumen)}>
                    <i className="nav-icon fas fa-folder" />
                    <span className="menu-text">Dokumen Perusahaan</span>
                    <i className="right fas fa-angle-left" />
                  </a>
                  <ul className={treeClass(openDokumen)}>
                    <li className="nav-item">
                      <Link to="/dokumen-perusahaan" className="nav-link">
                        <i className="nav-icon fas fa-sitemap" />
                        <span className="menu-text">Struktur Dokumen</span>
                      </Link>
                    </li>
                    {COMPANY_DOC_GROUPS.map((group) => {
                      const groupOpen = !!openCompanyDocGroups[group.key];
                      return (
                        <li key={group.key} className={`nav-item has-treeview ${groupOpen ? "menu-open" : ""}`} title={group.title}>
                          <a href="#!" className="nav-link" onClick={() => setOpenCompanyDocGroups(prev => ({...prev,[group.key]:!prev[group.key]}))}>
                            <i className="nav-icon fas fa-folder-open" />
                            <span className="menu-text">{group.title}</span>
                            <i className="right fas fa-angle-left" />
                          </a>
                          <ul className={treeClass(groupOpen) + " ml-3"}>
                            {group.items.map(([code,label]) => (
                              <li className="nav-item" key={code} title={label}>
                                <Link to={`/dokumen-perusahaan/${code}`} className="nav-link">
                                  <i className="nav-icon far fa-file-alt" />
                                  <span className="menu-text">{label}</span>
                                </Link>
                              </li>
                            ))}
                          </ul>
                        </li>
                      );
                    })}
                  </ul>
                </li>
              )}
              {/* END SIP_COMPANY_DOC_MENU_R1 */}

              {(isSuperAdmin || hasPerm("user.manage")) && (
                <li className="nav-item" title="Tambah User">
                  <Link to="/add-user" className="nav-link">
                    <i className="nav-icon fas fa-user-plus" />
                    <span className="menu-text">Tambah User</span>
                  </Link>
                </li>
              )}
            </ul>
          </nav>
        </div>
      </aside>

      <div className="content-wrapper p-3" style={{ minHeight: "100vh" }}>
        <section className="content">
          <div key={location.pathname} className="route-animate">
            <div className="container-fluid">{children}</div>
          </div>
        </section>
      </div>

      <footer className="main-footer text-sm text-center bg-white border-top">
        <strong>
          &copy; 2025 <span className="text-danger">Sarana Inti Presisi</span>.
        </strong>{" "}
        All rights reserved.
      </footer>

      {showRisalah && (
        <div className="modal-blanket" onClick={() => setShowRisalah(false)}>
          <div className="risalah-modal" onClick={(e) => e.stopPropagation()}>
            <div className="p-3 border-bottom d-flex align-items-center justify-content-between">
              <h5 className="m-0">
                <i className="fas fa-file-alt mr-2" /> Notice – Risalah Meeting
              </h5>
              <div className="d-flex align-items-center">
                {role !== "admin" && effDepts.length > 0 && (
                  <span className="mr-2 text-muted small">
                    Filter: {effDepts.join(", ")}
                  </span>
                )}
                <button
                  className="btn btn-sm btn-outline-secondary mr-2"
                  onClick={fetchRisalahNotice}
                >
                  <i className="fas fa-sync-alt" /> Refresh
                </button>
                <button
                  className="btn btn-sm btn-light"
                  onClick={() => setShowRisalah(false)}
                >
                  <i className="fas fa-times" /> Tutup
                </button>
              </div>
            </div>
            <div className="p-3">
              <div className="table-responsive">
                <table className="table table-sm table-striped">
                  <thead className="thead-light">
                    <tr>
                      <th>#</th>
                      <th>Masalah</th>
                      <th>Faktor</th>
                      <th>Perbaikan</th>
                      <th>PIC</th>
                      <th>Schedule</th>
                      <th>Dept</th>
                      <th>Judgement</th>
                      <th>Keterangan</th>
                    </tr>
                  </thead>
                  <tbody>
                    {risalahRows.length === 0 ? (
                      <tr>
                        <td colSpan="9" className="text-center text-muted">
                          Belum ada data
                        </td>
                      </tr>
                    ) : (
                      risalahRows.map((r, i) => (
                        <tr key={r.id}>
                          <td>{i + 1}</td>
                          <td style={{ whiteSpace: "pre-wrap" }}>{r.masalah}</td>
                          <td style={{ whiteSpace: "pre-wrap" }}>{r.faktor}</td>
                          <td style={{ whiteSpace: "pre-wrap" }}>{r.perbaikan}</td>
                          <td>{r.pic}</td>
                          <td>{(r.schedule || "").slice(0, 10)}</td>
                          <td>
                            <span className="badge badge-secondary">
                              {r.dept || "-"}
                            </span>
                          </td>
                          <td>{r.judgement}</td>
                          <td>{r.ket}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              <small className="text-muted">
                * Admin melihat semua departemen. User melihat sesuai deptRoles.
              </small>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

DashboardLayout.propTypes = {
  children: PropTypes.node,
  role: PropTypes.string,
  username: PropTypes.string,
  permissions: PropTypes.arrayOf(PropTypes.string),
  deptRoles: PropTypes.arrayOf(PropTypes.string),
};